// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { Separator } from '@tectonics/look-and-feel/volcanes/atoms';
import { getBankTransferDetail } from '@tectonics/prs/incoming-payment/get-bank-transfer-detail';
import { usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';

export function TicketBankBeneficiary(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const bankBeneficiary = getBankTransferDetail(incomingPayment).bank_beneficiary;

  return (
    <Root>
      <Term>Beneficiario</Term>
      <Separator direction="vertical" size={2} />
      <Definition>{bankBeneficiary}</Definition>
    </Root>
  );
}

const Root = styled.dl`
  text-align: left;
  padding: 1.2em;
`;

const Term = styled.dt`
  font-family: ${props => props.theme.fontFamily.sansSerif};
  font-size: 0.9em;
`;

const Definition = styled.dd`
  font-family: ${props => props.theme.fontFamily.display};
  font-size: 1.3em;
  font-weight: bold;
`;
